<script>
  import Clipboard from 'svelte-clipboard'

  import { ROUTES } from '../constants/constants'

  let isCopiedLink = false

  const toggleToastNotification = () => {
    isCopiedLink = !isCopiedLink
  }

  $: if (isCopiedLink) {
    setTimeout(toggleToastNotification, 1500)
  }
</script>

<Clipboard
  text={`Partecipa al sondaggio e scopri quanto la tua mobilità è sostenibile: ${document.location.origin}/${ROUTES.survey}`}
  let:copy
  on:copy={() => {
    toggleToastNotification()
  }}
>
  <div class="share-wrapper">
    <div class="toast-notification" style={isCopiedLink ? 'display: block' : 'display: none'}>
      Link copiato!
    </div>
    <svg
      on:click={copy}
      class="share"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="34" height="34" rx="17" fill="white" />
      <path
        d="M20.8637 20.1527C20.2765 20.1527 19.751 20.3845 19.3492 20.7477L13.8396 17.5409C13.8783 17.3632 13.9092 17.1854 13.9092 17C13.9092 16.8145 13.8783 16.6368 13.8396 16.4591L19.2874 13.2832C19.7046 13.6695 20.2533 13.9091 20.8637 13.9091C22.1465 13.9091 23.1819 12.8736 23.1819 11.5909C23.1819 10.3082 22.1465 9.27271 20.8637 9.27271C19.581 9.27271 18.5456 10.3082 18.5456 11.5909C18.5456 11.7763 18.5765 11.9541 18.6151 12.1318L13.1674 15.3077C12.7501 14.9213 12.2015 14.6818 11.591 14.6818C10.3083 14.6818 9.27283 15.7173 9.27283 17C9.27283 18.2827 10.3083 19.3182 11.591 19.3182C12.2015 19.3182 12.7501 19.0786 13.1674 18.6922L18.6692 21.9068C18.6306 22.0691 18.6074 22.2391 18.6074 22.4091C18.6074 23.6532 19.6196 24.6654 20.8637 24.6654C22.1078 24.6654 23.1201 23.6532 23.1201 22.4091C23.1201 21.165 22.1078 20.1527 20.8637 20.1527Z"
        fill="black"
      />
    </svg>
  </div>
</Clipboard>

<style>
  .share-wrapper {
    position: relative;
    margin-left: 0.75rem;
    margin-top: 0.35rem;
    height: min-content;
  }

  svg {
    cursor: pointer;
  }

  .toast-notification {
    position: absolute;
    top: 46px;
    right: 0;
    width: max-content;
    height: max-content;
    color: inherit;
    border: none;
    font: inherit;
    cursor: pointer;
    outline: inherit;
    font-size: 12px;
    padding: 0.3rem 0.5rem;
    background-color: #595959;
    color: white;
    border-radius: 50px;
  }
</style>
